const features = [
  {
    icon: 'ri-4k-line',
    title: '1080P 高清画质',
    desc: '所有影视资源默认提供高清画质在线观看，画面细腻锐利，色彩饱满真实，带来影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '不缓冲流畅播放',
    desc: '多线CDN加速与智能码率调节技术，确保在任何网络环境下都能不缓冲流畅播放，即点即播无需等待。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '快速找片',
    desc: '强大的搜索引擎和分类筛选系统，输入关键词即刻呈现相关结果，帮您在12万+影视资源中快速找片。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能推荐',
    desc: '基于深度学习的推荐算法，分析您的观影偏好，精准推送电视剧全集和电影大全，追剧更省心。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新80+部',
    desc: '自动追踪全网最新剧集完整版资源，热门剧集首播2小时内上线，确保您第一时间看到想追的剧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么选择黄瓜影院？五大核心优势为您揭晓</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 hover:shadow-lg transition-all text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}